<template>
  <div class="stockli__full-width-container robins-egg-bkgr pa-5">
    <div class="stockli-admin-container">
      <div class="h2">Unreturned Skis</div>
      <div class="participant-details-box">
        <div class="bold-text lg-text">Skis for {{ email }} that have not been returned:</div>

        <v-row class="mt-6 mb-0 mr-0 ml-0" dark>
            <v-text-field v-model="filter" append-icon="mdi-magnify" label="Search by Name or Ski" block single-line hide-details />
        </v-row>
      </div>

      <p class="mb-4">Check the box to mark as returned</p>
      <v-data-table :items="skis" :headers="headers" hide-default-footer :page.sync="page" :items-per-page="10" @page-count="pageCount = Math.min($event, 8)" disable-sort
        mobile-breakpoint="500" :loading="loading">
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.Returned="{ item }">
          <v-simple-checkbox :value="item.Returned" @input="ToggleReturned(item)" />
        </template>
      </v-data-table>
      <div class="pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";

export default {
  name: "UnreturnedSkis",
  components: {
  },
  data: () => ({
    skis: [],
    loading: false,
    headers: [
      { text: "Name", value: "Participant.Full_Name" },
      { text: "Date", value: "Date" },
      { text: "Ski", value: "Name" },
      { text: "Size", value: "Size" },
      { text: "Returned", value: "Returned" },
    ],
    filterTimeout: undefined,
    filter: "",

    page: 1,
    pageCount: 0,
  }),
  computed: {
    email() {
      return this.$store.state.email;
    },
  },
  mounted() {
    this.RefreshSkis();
  },
  methods: {
    async RefreshSkis() {
      try {
        this.loading = true;
        this.skis = await API.GetUnreturnedSkis(this.filter);
      } finally {
        this.loading = false;
      }
    },

    async ToggleReturned(ski) {
      ski.Returned = !ski.Returned;
      await API.UpdateParticipantSki(ski.id, { Returned: ski.Returned });
    },
  },
  watch: {
    filter() {
      // delay / debounce until x ms have passed
      if (this.filterTimeout) clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.RefreshSkis();
      }, 500);
    },
  },
}
</script>
<style scoped lang="scss"></style>
